import { isDigitsOnly } from "common/src/utils/stringUtils";
import {
	DISCOVER_GAMES_CLUB_TEAM_SEARCH_FILTER_FIELDS,
	DiscoverGamesClubTeamSearchFilterField,
} from "./constants";

/**
 * Must stay in sync with FulltextSearchHelper::MIN_FULLTEXT_LENGTH and
 * FulltextSearchHelper::isApplicableEntityNameSearch() (PHP).
 */
export const DISCOVER_GAMES_NAME_SEARCH_MIN_LENGTH = 4;

function isClubTeamSearchFilterField(field: string): field is DiscoverGamesClubTeamSearchFilterField {
	return (DISCOVER_GAMES_CLUB_TEAM_SEARCH_FILTER_FIELDS as readonly string[]).includes(field);
}

export function isApplicableDiscoverGamesNameSearch(value: unknown): boolean {
	if (value == null || typeof value !== "string") {
		return false;
	}
	const trimmed = value.trim();
	if (trimmed === "") {
		return false;
	}
	if (isDigitsOnly(trimmed)) {
		return true;
	}
	return [...trimmed].length >= DISCOVER_GAMES_NAME_SEARCH_MIN_LENGTH;
}

export function shouldIncludeDiscoverGamesSearchField(
	field: string,
	filterValues: Record<string, unknown>,
): boolean {
	if (isClubTeamSearchFilterField(field)) {
		return isApplicableDiscoverGamesNameSearch(filterValues[field]);
	}
	return Boolean(filterValues[field]);
}
